/* eslint-disable i18next/no-literal-string -- css not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

export const steps = defineSlotRecipe({
  className: 'chakra-steps',
  slots: ['root', 'list', 'title', 'description', 'separator', 'indicator', 'item', 'trigger', 'content'],

  variants: {
    variant: {
      solid: {
        indicator: {
          // eslint-disable-next-line @typescript-eslint/naming-convention -- css pseudostyles convention
          _incomplete: {
            borderWidth: 'var(--steps-thickness)',
          },
          // eslint-disable-next-line @typescript-eslint/naming-convention -- css pseudostyles convention
          _current: {
            bg: 'colorPalette.muted',
            borderWidth: 'var(--steps-thickness)',
            borderColor: 'colorPalette.solid',
            color: 'colorPalette.fg',
          },
          // eslint-disable-next-line @typescript-eslint/naming-convention -- css pseudostyles convention
          _complete: {
            bg: 'colorPalette.solid',
            borderColor: 'colorPalette.solid',
            color: 'colorPalette.contrast',
          },
        },

        separator: {
          // eslint-disable-next-line @typescript-eslint/naming-convention -- css pseudostyles convention
          _complete: {
            bg: 'colorPalette.solid',
          },
        },
      },

      progress: {
        indicator: {
          background: 'none',
          border: 'none',
          borderRadius: 0,
          width: 'unset',
          // eslint-disable-next-line @typescript-eslint/naming-convention -- css pseudostyles convention
          _current: {
            background: 'none',
            color: 'gray.500',
          },
          // eslint-disable-next-line @typescript-eslint/naming-convention -- css pseudostyles convention
          _complete: {
            background: 'gray.500',
            color: 'gray.200',
          },
          // eslint-disable-next-line @typescript-eslint/naming-convention -- css pseudostyles convention
          _incomplete: {
            background: 'none',
            color: 'gray.500',
          },
        },
      },
    },
    size: {
      xs: {
        root: {
          gap: '1',
        },
        list: {
          '--steps-size': 'sizes.2',
          '--steps-icon-size': 'sizes.1',
          textStyle: 'xs',
        },
        title: {
          textStyle: 'sm',
        },
        indicator: {
          marginTop: '1.5',
        },
      },
    },
  },

  defaultVariants: {
    variant: 'solid',
  },
});
